import { jwtDecode } from 'jwt-decode';

export function getTokenStatus(token, leewayMs = 30_000) {
    // token ausente o mal formado
    if (!token) {
        return { isExpired: true, expiresAt: null, remainingMs: 0 };
    }

    try {
        let { exp } = jwtDecode(token);
        if (!exp) {
            // sin claim exp ⇒ no podemos saber la fecha; lo tratamos como vigente
            return { isExpired: false, expiresAt: null, remainingMs: Infinity };
        }

        exp = Number(exp);
        if (Number.isNaN(exp)) throw new Error('exp no numérico');
        // console.log('exp:', exp);

        // segundos -> milisegundos si hace falta
        const expMs = exp < 1e12 ? exp * 1000 : exp;
        const now = Date.now();
        const remaining = expMs - now;

        return {
            isExpired: remaining <= leewayMs,      // con margen opcional
            expiresAt: new Date(expMs),
            remainingMs: Math.max(0, remaining),
        };
    } catch (e) {
        console.warn('jwtDecode error:', e);
        return { isExpired: true, expiresAt: null, remainingMs: 0 };
    }
}
